export default __webpack_public_path__ + "static/media/word_icon.20f65e93.png";